module.exports = __webpack_public_path__ + "img/img-2465.ad7dc601.jpg";